import * as React from 'react'
import { connect, Dispatch } from 'react-redux'
import { Drawer as SideMenu } from '../components/Drawer'
import { DrawerItem } from '../components/DrawerItem'
import { RouterAction, routerActions } from 'react-router-redux'
import { ActionType, Actions } from '../actions/drawer'
import { StoreState } from '../reducers'
import { ROUTES } from '../constants/routes'
import '../styles/App.scss'
import '../styles/Drawer.scss'
import { SideMenuHeader } from '../components/SideMenuHeader'
import { ClientInfo, Preference } from '../types'
import { JobStatus } from '../types/enums'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'
import { ActionType as SignInActionType, Actions as SignInActions } from '../actions/signIn'
import ReactFocusLock from 'react-focus-lock'
import {HELP_LINK} from '../constants/routes'

interface DrawerProps {
  isOpen: boolean
  client: ClientInfo
  tutorialLink: Preference
  routePush: (location: string) => RouterAction
  closeDrawer: () => ActionType
  status: string
  jobCategoryName: string
}

interface DrawerState {
  classes?: any
  status: string
  isThereActiveJob: boolean
  href: string
}

const styles = {
  drawerPaper: {
    position: 'relative',
    width: 250
  }
}

class Drawer extends React.Component<DrawerProps, DrawerState> {

  constructor(props: any) {
    super(props)
    this.state = {
      status: this.props.status,
      isThereActiveJob: false,
      href: ROUTES.PICKUP_LOCATION
    }
  }

  checkStatus = (status) => {
    if (status === JobStatus.CREATED || status === JobStatus.UNDER_REVIEW ||
      status === JobStatus.BIDDING_ACTIVE || status === JobStatus.BIDS_AWAITING_ACCEPTANCE) {
      this.setState({
        isThereActiveJob: true,
        href: ROUTES.VIEW_BIDS
      })
    } else if (status === JobStatus.ACCEPTED || status === JobStatus.CONFIRM_ARRIVAL ||
      status === JobStatus.HAULER_ARRIVING || status === JobStatus.WAITING_FOR_PAYMENT_AUTHORIZATION ||
      status === JobStatus.REVIEW_ACCEPTED) {
      this.setState({
        isThereActiveJob: true,
        href: ROUTES.BID_ACCEPTED
      })
    } else if (status === JobStatus.COMPLETED) {
      this.setState({
        isThereActiveJob: true,
        href: ROUTES.REVIEW_HAULER
      })
    } else {
      this.setState({
        href: ROUTES.PICKUP_LOCATION
      })
    }
  }

  componentDidMount() {
    this.checkStatus(this.props.status)
  }

  onDrawerClose = () => {
    this.props.closeDrawer()
  }

  onItemSelected = (data: any) => {
    if (data.isExternal) {
      window.open(data.href, '_blank')
      return
    }
    if (data.href) {
      this.props.routePush(data.href)
    }
    if (data.closeOnClick) {
      this.props.closeDrawer()
    }
  }

  componentWillReceiveProps(nextProps: any) {
    if (this.props.status !== nextProps.status) {
      this.setState({
        status: nextProps.status
      })
      this.checkStatus(nextProps.status)
    }
  }

  render() {
    const firstNameHeader = this.props.client && this.props.client.firstName ? this.props.client.firstName : ''
    const lastNameHeader = this.props.client && this.props.client.lastName ? this.props.client.lastName : ''
    const tutorialLink = this.props.tutorialLink ? this.props.tutorialLink.value : ''
    return (
      <div className="App">
        <SideMenu
          isOpen={this.props.isOpen}
          onClose={this.onDrawerClose}
          closeOnOutsideClick={true}
        >
          <ReactFocusLock disabled={!this.props.isOpen}>
            <SideMenuHeader
              firstName={firstNameHeader}
              lastName={lastNameHeader}
            />
            <DrawerItem
              isSelected={false}
              data={{
                href: this.state.href,
                closeOnClick: true
              }}
              title={StringResources.getString(Strings.SideMenu.Items.Home.title)}
              icon="my-job.png"
              onClick={this.onItemSelected}
            />
            <DrawerItem
              isSelected={false}
              data={{
                href: ROUTES.COMPLETED_JOBS,
                closeOnClick: true
              }}
              title={StringResources.getString(Strings.SideMenu.Items.CompletedJobs.title)}
              icon="completed-jobs.png"
              onClick={this.onItemSelected}
            />
            <DrawerItem
              isSelected={false}
              data={{
                href: ROUTES.PREFERENCES,
                closeOnClick: true
              }}
              title={StringResources.getString(Strings.SideMenu.Items.Preferences.title)}
              icon="preferences.png"
              onClick={this.onItemSelected}
            />
            <DrawerItem
              isSelected={false}
              data={{
                href: ROUTES.CONTACT,
                closeOnClick: true
              }}
              title={StringResources.getString(Strings.SideMenu.Items.ContactGoTrashy.title)}
              icon="contact-go-trashy.png"
              onClick={this.onItemSelected}
            />
            <DrawerItem
              isSelected={false}
              data={{
                href: tutorialLink,
                closeOnClick: true,
                isExternal: true
              }}
              title={StringResources.getString(Strings.SideMenu.Items.Tutorial.title)}
              icon="tutorial.png"
              onClick={this.props.tutorialLink ? this.onItemSelected : undefined}
            />
            <DrawerItem
              isSelected={false}
              data={{
                href: HELP_LINK,
                closeOnClick: true,
                isExternal: true
              }}
              title={StringResources.getString(Strings.SideMenu.Items.Help.title)}
              icon="q-mark.png"
              onClick={this.onItemSelected}
            />
            <DrawerItem
              isSelected={false}
              data={{
                href: ROUTES.LOG_OUT,
                closeOnClick: true
              }}
              title={StringResources.getString(Strings.SideMenu.Items.LogOut.title)}
              icon="logout.png"
              onClick={this.onItemSelected}
            />
          </ReactFocusLock>
        </SideMenu>
        {this.props.children}
      </div>
    )
  }

}

function mapStateToProps(state: StoreState) {
  return {
    isOpen: state.drawer.isOpen,
    client: state.auth.user,
    tutorialLink: state.auth.tutorialLink,
    status: state.jobDetails.status,
    jobCategoryName: state.jobDetails.jobCategoryName,
    isClientAutorized: state.auth.isSigned
  }
}

function mapDispatchToProps(dispatch: Dispatch<RouterAction | ActionType | SignInActionType>) {
  return {
    routePush: (location: string) => dispatch(routerActions.push(location)),
    setClientInfo: (userData: ClientInfo) => dispatch(SignInActions.authorize(userData)),
    closeDrawer: () => dispatch(Actions.close())
  }
}

export const DrawerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Drawer)



// WEBPACK FOOTER //
// ./src/containers/DrawerContainer.tsx